<template>
  <div class="vl-person-interface">
    <el-tabs v-model="tabName">
      <el-tab-pane label="已申请" name="1">
        <div class="queryCondition">
          <div class="search-main">
            <!-- <el-select v-model="grouping" clearable placeholder="选择接口分组" style="width: 150px;margin-right: 10px;">
              <el-option v-for="item in options" :key="item.apiGroupId" :label="item.groupName"
                        :value="item.apiGroupId">
              </el-option>
            </el-select> -->
            <el-cascader
              v-model="grouping"
              style="width: 150px;margin-right: 10px;"
              placeholder="选择接口分组"
              :options="options"
              :props="{ checkStrictly: true }"
              clearable></el-cascader>
            <el-select v-model="appStatus" clearable placeholder="选择状态" style="width: 120px;margin-right: 10px;">
              <el-option v-for="item in stateList" :key="item.value" :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
            <el-input v-model="keyWord" placeholder="请输入接口名称或API名称查询"
                      style="width: 240px;margin-right: 10px;"></el-input>
            <el-button type="primary" :loading="searchLoading" @click="getInterfaceData">查询</el-button>
          </div>
          <!--<div class="search-right">
            <el-button @click="subInterface">订阅接口</el-button>
          </div>-->
        </div>
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="apiGroupName" label="接口分组" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="apiDesignation" label="接口名称" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="apiName" label="API名称" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="apiDescribe" label="接口说明" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="applyDate" label="申请时间" width="160" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="auditStatus" label="审核状态" show-overflow-tooltip>
            <template slot-scope="scope">
                                    <span>{{
                                        scope.row.auditStatus == 1 ? '已通过' : scope.row.auditStatus == 2 ? '审核中' :
                                          ''
                                      }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="cancelSub(scope.row.apiCode)"
                         :disabled="scope.row.cancel != 0">取消订阅
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination v-if="pagination.total > 0" background layout="prev, pager, next"
                       :current-page.sync="pagination.pageNo"
                       :total="pagination.total" @current-change="handleCurrentChange"
                       :page-size.sync="pagination.pageSize">
        </el-pagination>
      </el-tab-pane>

      <el-tab-pane label="未申请" name="2">
        <interface-sub></interface-sub>
      </el-tab-pane>

      <el-tab-pane label="已授权数据" name="3">
        <p class="warning-tips">
          <i class="el-icon-warning"></i>数据安全告知:在未得到数据授权单位书面许可时，禁止随意传阅数据!
        </p>
        <filter-table
          :get-api="getListApiScope"
          :filter-items="filterItems"
          :ext-params="extParams"
          :pagination="false">
          <el-table-column label="接口名称" prop="apiName" show-overflow-tooltip></el-table-column>
          <el-table-column label="数据范围" prop="scopeName" show-overflow-tooltip></el-table-column>
          <el-table-column label="接口编码" prop="apiCode" show-overflow-tooltip></el-table-column>
          <el-table-column label="数据授权时间" prop="createTime"></el-table-column>
        </filter-table>
      </el-tab-pane>

      <el-tab-pane label="数据授权日志" name="4">
        <filter-table
          :get-api="getListApiScopeLog"
          :filter-items="filterItems"
          :ext-params="extParams">
          <el-table-column label="接口名称" prop="apiName" show-overflow-tooltip></el-table-column>
          <el-table-column label="数据范围" prop="scopeName" show-overflow-tooltip></el-table-column>
          <el-table-column label="接口编码" prop="apiCode" show-overflow-tooltip></el-table-column>
          <el-table-column label="操作" prop="operatorName" width="120">
            <template v-slot="scope">{{ scope.row.status ? "授权" : "取消授权" }}</template>
          </el-table-column>
          <el-table-column label="操作时间" prop="createTime" width="120"></el-table-column>
        </filter-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import {
  PersonalPostApiInfoList,
  PersonalPostDeleteApiApply,
  PersonalGetApiGroupList,
  getListApiScope,
  getListApiScopeLog,
} from '@/views/index/api/personalCenter/api.personalCenter.js';
import COMMON from "@/utils/common";
import InterfaceSub from "./appManageInterfaceSub.vue";
import FilterTable from "@/views/index/components/personalCenter/appManage/FilterTable.vue";

export default {
  components: {FilterTable, InterfaceSub},
  data() {
    return {
      appId: null,
      tabName: "1",//Tab名称
      pagination: {
        pageNo: 1,
        pageSize: 10,
        total: 0
      },
      tableData: [],
      grouping: "",
      keyWord: "",
      appStatus: "",
      options: [],
      stateList: [
        { value: '1', label: '已通过'},
        { value: '2', label: '审核中'},
      ],
      searchLoading: false,
      // 积分数据授权
      getListApiScope,
      getListApiScopeLog,
      filterItems: [{name: "searchKey", type: "input", placeholder: "请输入接口名称或接口编码查询"}],
      extParams: {appId: this.$route.query.appId},
    }
  },
  mounted() {
    this.appId = this.$route.query.appId;
    this.getInterfaceData();
    this.getApiGroup();
  },
  methods: {
    handleCurrentChange(val) {
      this.pagination.pageNo = val;
      this.getInterfaceData();
    },
    // 获取分组list
    getApiGroup() {
      let that = this;
      PersonalGetApiGroupList().then(res => {
        if (res && res.result) {
          that.options = this.setTreeData(res.result);
          console.log(that.options);
        }
      })
    },
    //树状结构参数调整
    setTreeData(resultList) {
      let dataList = [];
      if (COMMON.isEmpty(resultList)) {
        this.treeData = [];
        return;
      }
      let that = this;
      resultList.forEach(function (result) {
        let temp = {
          value: result.apiGroupId,
          label: result.groupName,
        };
        if (COMMON.isNotEmpty(result.children)) {
          temp.children = that.setTreeData(result.children);
        }
        dataList.push(temp);
      });
      return dataList;
    },
    // 获取数据
    getInterfaceData() {
      console.log("grouping:", this.grouping);
      this.searchLoading = true;
      let apiGroup = "";
      if (this.grouping.length > 0) {
        apiGroup = this.grouping[this.grouping.length - 1];
      }
      console.log("apiGroup:", apiGroup);
      let params = {
        appId: this.appId,
        apiGroupId: apiGroup,
        apiStatus: this.appStatus,
        pageNo: this.pagination.pageNo,
        pageSize: this.pagination.pageSize,
        searchKey: this.keyWord
      }
      PersonalPostApiInfoList(params).then(res => {
        console.log("执行方法");
        if (res && res.result) {
          this.tableData = res.result.list;
          this.pagination.total = res.result.totalNum;
        }
        this.searchLoading = false;
      })
    },
    // 取消订阅
    cancelSub(code) {
      let params = {
        appId: this.appId,
        apiCode: code
      }
      PersonalPostDeleteApiApply(params).then(res => {
        if (res) {
          this.$MyMessage(res.message, 'success');
          this.getInterfaceData();
        }
      })
    },
    subInterface() {
      this.$router.push({name: 'personInterfaceSub', query: {appId: this.appId}})
    }
  }
}
</script>
<style lang="scss">
.vl-person-interface {
  width: 100%;

  .el-pagination {
    text-align: center;
    margin: 30px 0 50px;
  }

  .queryCondition {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }

  .queryCondition .el-button {
    padding: 10px 24px !important;
  }

  .queryCondition .el-button--default {
    border: 1px solid #4286F5 !important;
    color: #4286F5 !important;
  }

  .has-gutter tr th {
    background-color: #F1F8FF !important;
    border-bottom: none !important;
  }

  .warning-tips {
    font-size: 16px;
    margin-bottom: 15px;

    .el-icon-warning {
      font-size: 18px;
      color: #E6A23C;
      margin-right: 5px;
    }
  }
}
</style>